// Local asset paths (self-host). Served by nginx / CRA public/.
export const ASSETS = {
  logo: "/assets/logo.png",
  favicon: "/assets/favicon.ico",
  hero: "/assets/hero.jpg",
  sim: "/assets/sim.webp",
  bodycamOrange: "/assets/bodycam-orange.webp",
  bodycamBlack: "/assets/bodycam-black.webp",
  uphonePtt: "/assets/uphone-ptt.webp",
  estalkyPtt: "/assets/estalky-e1201.jpg",
  estalkyEx: "/assets/estalky-e120ex.jpg",
  pdaScanner: "/assets/pda-scanner.webp",
  pdaScannerAlt: "/assets/pda-scanner-alt.webp",
  commandTablet: "/assets/command-tablet.webp",
  ruggedTablet: "/assets/rugged-tablet.webp",
  appStoreBadge: "/assets/app-store-badge.svg",
  googlePlayBadge: "/assets/google-play-badge.png",
  appIcon: "/assets/app-icon.png",
};

export const APP_LINKS = {
  appStore: "https://apps.apple.com/us/app/ptt-nz/id6804854600",
  googlePlay: "https://play.google.com/store/apps/details?id=com.pttnz.app",
};

export const PRODUCT_CATEGORIES = [
  { id: "ptt-radios", label: "PTT Radios" },
  { id: "body-cameras", label: "Body Cameras" },
  { id: "iot-hardware", label: "IoT & Rugged" },
  { id: "sims-esims", label: "Multi-Network SIMs & eSIMs" },
];

export const PRODUCTS = [
  {
    id: "uphone-ptt",
    name: "Uphone Rugged PTT Handset",
    category: "ptt-radios",
    tagline: "Full-keypad cellular PTT with mission-critical comms.",
    image: ASSETS.uphonePtt,
    highlights: ["Android-based PTT app", "Tri-network SIM ready", "IP67 rugged build", "Emergency SOS"],
  },
  {
    id: "estalky-e1201",
    name: "Estalky E1201 4G PTT Radio",
    category: "ptt-radios",
    tagline: "Compact 4G LTE radio with nationwide coverage.",
    image: ASSETS.estalkyPtt,
    highlights: ["Real-time GPS", "Group & private calls", "Long battery life", "POC over LTE"],
  },
  {
    id: "estalky-e120ex",
    name: "Estalky E120EX ATEX PTT Radio",
    category: "ptt-radios",
    tagline: "Intrinsically safe (Ex) radio for hazardous zones.",
    image: ASSETS.estalkyEx,
    highlights: ["ATEX / IECEx certified", "Zone 1 / Zone 2 use", "Tri-network SIM", "Tough industrial build"],
  },
  {
    id: "bodycam-pro",
    name: "Uphone Body Camera — Pro",
    category: "body-cameras",
    tagline: "Live-stream evidence-grade body camera.",
    image: ASSETS.bodycamOrange,
    highlights: ["1440p recording", "Live stream over LTE", "12hr battery", "Tamper-proof storage"],
  },
  {
    id: "bodycam-x",
    name: "Uphone Body Camera — X Series",
    category: "body-cameras",
    tagline: "Rugged on-body camera with PTT & GPS.",
    image: ASSETS.bodycamBlack,
    highlights: ["Built-in PTT", "Night vision IR", "Drop & water rated", "Audit-trail uploads"],
  },
  {
    id: "rugged-tablet",
    name: "Rugged Field Tablet",
    category: "iot-hardware",
    tagline: "Glove-friendly 10″ tablet for crews on the move.",
    image: ASSETS.ruggedTablet,
    highlights: ["IP68 rated", "Hot-swap battery", "GNSS + LTE", "Field dispatch ready"],
  },
  {
    id: "command-tablet",
    name: "Dispatch & Command Tablet",
    category: "iot-hardware",
    tagline: "Visual command & dispatch for fleet operations.",
    image: ASSETS.commandTablet,
    highlights: ["Multi-feed video", "Live fleet map", "Group control", "Evidence sync"],
  },
  {
    id: "pda-scanner",
    name: "Industrial PDA Scanner",
    category: "iot-hardware",
    tagline: "Logistics-grade PDA with PTT & scanner.",
    image: ASSETS.pdaScanner,
    highlights: ["1D/2D scan engine", "Android 12", "PTT key", "Long-shift battery"],
  },
  {
    id: "pda-mobile",
    name: "Mobile PDA Terminal",
    category: "iot-hardware",
    tagline: "Slim-form scanner for retail & delivery.",
    image: ASSETS.pdaScannerAlt,
    highlights: ["Fast 4G LTE", "Barcode + NFC", "Drop tested", "Multi-network SIM"],
  },
  {
    id: "multi-sim",
    name: "PTT NZ Global Multi-Network SIM",
    category: "sims-esims",
    tagline: "One SIM. Every network. Strongest signal wins.",
    image: ASSETS.sim,
    highlights: ["Spark + 2degrees + One NZ", "Roams Australia's key carriers", "190+ countries · 600+ carriers", "Single-APN, no reconfiguration"],
  },
  {
    id: "esim",
    name: "PTT NZ Global Multi-Network eSIM",
    category: "sims-esims",
    tagline: "Remote-provisioned eSIM with global multi-network roaming.",
    image: ASSETS.sim,
    highlights: ["Provisioned over the air", "3 NZ networks + AU + global", "Fits your own hardware", "Managed in the Connectivity Portal"],
  },
];

export const CONTACT_DETAILS = {
  phone: "03 360 3011",
  phoneHref: "tel:+6433603011",
  // Email is stored split to avoid rendering the full literal in the initial DOM.
  // Use <ObfuscatedEmail /> for visible display. `email` + `emailHref` remain
  // available for structured data / backend-only use.
  emailUser: "service",
  emailDomain: "pttnz.net",
  email: "service@pttnz.net",
  emailHref: "mailto:service@pttnz.net",
  address: "14 Hazeldean Road, Addington, Christchurch 8024, New Zealand",
  mapsHref: "https://www.google.com/maps/search/?api=1&query=14+Hazeldean+Road+Addington+Christchurch+8024",
};
